export default class TeamTableRow {
  leagueAvg = 0;
  totalAccumulated = 0;
  period1 = 0;
  period2 = 0;
  period3 = 0;
  period4 = 0;
  period5 = 0;
  period6 = 0;
  items = null;
  generalName = '';

  /**
   * @author Alejandro
   * @param {string} category - Category or subcategory name
   * @param {Array<number>} categoryIds - Own team categoryIds to filter plays
   * @param {Array<number>} rCategoryIds - Rival team categoryIds to filter plays
   * @param {string} translationKey - Translation key for the category or subcategory name
   * @param {Array<Object>} nestedRows - Nested subcategories
   */
  constructor(category, categoryIds, rCategoryIds, translationKey, nestedRows, generalName) {
    this.category = category;
    // CategoryIds from own team
    this.categoryIds = categoryIds;
    // CategoryIds from rival team
    this.rCategoryIds = rCategoryIds;
    this.translationKey = translationKey;
    if (nestedRows) this.createItems(nestedRows);
    this.generalName = generalName;
  }

  createItems(items) {
    this.items = [];
    for (let item of items) {
      this.items.push(
        new TeamTableRow(
          item.category,
          item.categoryIds,
          item.rCategoryIds,
          item.translationKey,
          item.items,
          item.generalName,
        ),
      );
    }
  }

  addAvgPlay(play, timeSelected, playValueIndex, seasonGamesOrTeams, parentRow) {
    // If this row has not categoryIds, it is a parent row
    if (this.categoryIds || this.rCategoryIds) {
      // Check if current play.categoryId is in categoryIds
      if (
        timeSelected.includes(play[playValueIndex.section]) &&
        ((this.categoryIds && this.categoryIds.includes(play[playValueIndex.categoryId])) ||
          (this.rCategoryIds && this.rCategoryIds.includes(play[playValueIndex.categoryId])))
      ) {
        // if this row has parent row, increment it's period
        if (parentRow) parentRow.leagueAvg += play[playValueIndex.total] / seasonGamesOrTeams;
        this.leagueAvg += play[playValueIndex.total] / seasonGamesOrTeams;
        return true;
      }
    } else if (this.items) {
      for (let item of this.items) {
        if (item.addAvgPlay(play, timeSelected, playValueIndex, seasonGamesOrTeams, this)) {
          return true;
        }
      }
    }
  }

  addPlay(play, timeSelected, playValueIndex, teamId, parentRow) {
    // If this row has not categoryIds, it is a parent row
    if (this.categoryIds || this.rCategoryIds) {
      // Check if current play.categoryId is in categoryIds or rCategoryIds
      if (
        (this.categoryIds &&
          this.categoryIds.includes(play[playValueIndex.categoryId]) &&
          teamId === play[playValueIndex.teamId]) ||
        (this.rCategoryIds &&
          teamId !== play[playValueIndex.teamId] &&
          this.rCategoryIds.includes(play[playValueIndex.categoryId]))
      ) {
        // if this row has parent row, increment it's period
        if (parentRow) parentRow[`period${play[playValueIndex.section]}`]++;
        this[`period${play[playValueIndex.section]}`]++;
        // Check selected time periods with current play time period
        if (!timeSelected || timeSelected.includes(play[playValueIndex.section])) {
          if (parentRow) parentRow.totalAccumulated++;
          this.totalAccumulated++;
        }
        return true;
      }
    } else if (this.items) {
      for (let item of this.items) {
        if (item.addPlay(play, timeSelected, playValueIndex, teamId, this)) {
          return true;
        }
      }
    }
  }
}
